/**
 * The company's Auto-Provision setting, read off whichever payload carries it.
 *
 * Settings › General names it as `auto_provision_license`, with `AUTO_PROVISION_OFF`
 * meaning off, and the server mirrors that as `auto_provision_license_active`. The business
 * payload carries the same pair for users who may read the business but not its
 * Settings — an HR user holds employee-write alone (D6).
 */
export interface AutoProvisionSource {
    auto_provision_license?: string | null;
    auto_provision_license_active?: boolean;
}

/**
 * The value `auto_provision_license` holds while Auto-Provision is off. The server
 * keeps this spelling as the column's default and reads it as "provision no seat".
 * No license the API lists carries it, so it never names a tier.
 */
export const AUTO_PROVISION_OFF = 'scan_only';

/** The tier Auto-Provision assigns; '' when it is off; null when `source` does not carry the setting. */
export function autoProvisionTier(source: AutoProvisionSource | null | undefined): string | null {
    const slug = source?.auto_provision_license;
    if (typeof slug !== 'string') return null;
    if (!slug || slug === AUTO_PROVISION_OFF || source?.auto_provision_license_active === false) return '';
    return slug;
}
